import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import plugin from './plugins/index'
import './plugins/echarts.js'
import Empty from './components/Empty'
Vue.component('empty',Empty)
import './plugins/element.js'
import './plugins/vant.js'
import './plugins/dataV.js'
import './assets/font/iconfont.css'
import './assets/css/main.css'
import {_isMobile} from "@/utils/utils";
if (_isMobile()) {
  import('./assets/css/mobile.css');
} else {
  import('./assets/css/web.css');
}
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
import 'vue-orgchart/dist/style.min.css'
import permission from "@/plugins/permission";
Vue.directive("permission", permission);

Vue.use(plugin)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
